import LocalizedStrings from 'react-localization'
import en from './en.json'
import fr from './fr.json'
import de from './de.json'
import it from './it.json'
import pt from './pt.json'
import ru from './ru.json'

export const key = new LocalizedStrings({
  en: en,
  fr: fr,
  de: de,
  it: it,
  pt: pt,
  ru: ru,
})

export const $ = (stringKey, ...rest) => key.formatString(stringKey, ...rest)
